<div class="modal fade show meeting-form-modal meeting-details create-meeting create-voting">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">
          {{ 'voting.one time password' | translate }}
        </h4>

        <button type="button" class="close" aria-label="Close" (click)="cancelPop.emit()">
          <span>&times;</span>
        </button>
      </div>

      <div class="modal-body">

        <div *ngIf='dataLoading' class="dataLoading">
          <mat-spinner class="m-auto" diameter="30"></mat-spinner>
        </div>

        <ng-container *ngIf="!dataLoading">
          <div class="pass" *ngIf="passwordLabel  && passwordLabel.isOtpNotFromSms">
            <span>{{ 'voting.your password is' | translate }}:</span>
            <span *ngIf="passwordLabel.password != null">
              {{passwordLabel.password}}
            </span>
          </div>

          <div class="form-group">
            <mat-form-field>
              <mat-label> {{ 'voting.one time password' | translate }}</mat-label>
              <input matInput [formControl]="passwordCtr" maxlength="4" appOnlynumber>
              <mat-error *ngIf="passwordCtr.hasError('required')">
                {{ 'messages.required' | translate }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="modal-btns mt-5">
            <button type="reset" class="close closebtn" aria-label="Close"
              (click)="cancelPop.emit()" [disabled]="loading">
              {{ 'meetings.cancel' | translate }}
            </button>
            <button mat-raised-button class="btn customBtn"
              (click)="submit()" [disabled]="loading"
              [ngClass]="{ 'loading': loading }">
              {{ 'voting.Submit' | translate }}
            </button>
          </div>
        </ng-container>

      </div>
    </div>
  </div>
</div>
